import { getRealizedTotalInvested, createFilteredList } from './investments';

export default class Realized {
  constructor(iangels, icapital, lpsData, filters, entities) {
    this.totalInvestments = 0;
    if (filters.length > 0 && filters.length !== entities.length) {
      this.iangels = [];
      this.icapital = [];
      this.lpsData = [];

      createFilteredList(iangels, filters, this.iangels, true, false);
      createFilteredList(icapital, filters, this.icapital, true, false);

      filters.forEach((element) => {
        lpsData?.forEach((data) => {
          if (data.entityName === element.name) {
            this.lpsData.push(data);
            this.totalInvestments += data?.realizedInvestments?.length;
          }
        });
      });
    } else {
      this.iangels = iangels;
      this.icapital = icapital;
      this.lpsData = lpsData;
      lpsData?.forEach((data) => {
        this.totalInvestments += data?.realizedInvestments?.length;
      });
    }
    this.totalInvestments += this.iangels?.length;
    this.totalInvestments += this.icapital?.length;

    this.iangelsTotalInvested = getRealizedTotalInvested(this.iangels);
    this.icapitalTotalInvested = getRealizedTotalInvested(this.icapital);
    this.lpsDataTotalInvested = [];

    this.lpsData?.forEach((section) =>
      this.lpsDataTotalInvested.push(getRealizedTotalInvested(section?.realizedInvestments))
    );

    this.totalInvested =
      this.iangelsTotalInvested?.totalInvested +
      this.icapitalTotalInvested?.totalInvested +
      this.lpsDataTotalInvested?.reduce((pv, cv) => pv + (cv?.totalInvested || 0), 0);

    this.lastValue =
      this.iangelsTotalInvested?.lastValue +
      this.icapitalTotalInvested?.lastValue +
      this.lpsDataTotalInvested?.reduce((pv, cv) => pv + (cv?.lastValue || 0), 0);

    this.investmentSummary = {
      totalInvested: this.totalInvested,
      lastValue: this.lastValue,
      change: this.totalInvested !== 0 ? Math.round((this.lastValue / this.totalInvested - 1) * 100) : 0,
    };
  }
  get getTotalInvestments() {
    return this.totalInvestments;
  }
  get getIangelsTotalInvested() {
    return this.iangelsTotalInvested;
  }

  get getIcapitalTotalInvested() {
    return this.icapitalTotalInvested;
  }

  get getLpsDataTotalInvested() {
    return this.lpsDataTotalInvested;
  }

  get getInvestmentSummary() {
    return this.investmentSummary;
  }

  get getIangels() {
    return this.iangels;
  }

  get getIcapital() {
    return this.icapital;
  }

  get getLpsData() {
    return this.lpsData;
  }
}
